import { DashboardMetricKey } from "../../enums";
import { DashboardMetrics } from "../../../types/dashboard";

export const getMetricPropertyName = (
  metricKey: DashboardMetricKey
): keyof DashboardMetrics => {
  const mapping: Record<DashboardMetricKey, keyof DashboardMetrics> = {
    [DashboardMetricKey.CancelledByUser]: "cancelledByUser",
    [DashboardMetricKey.CancelledByAdmin]: "cancelledByAdmin",
    [DashboardMetricKey.UserReservations]: "userReservations",
    [DashboardMetricKey.AdminReservations]: "adminReservations",
    [DashboardMetricKey.UsersOnWaitingList]: "usersOnWaitingList",
    [DashboardMetricKey.NoShowReservations]: "noShowReservations",
    [DashboardMetricKey.UnconfirmedReservations]: "unconfirmedReservations",
    [DashboardMetricKey.ConfirmedRevenue]: "confirmedRevenue",
    [DashboardMetricKey.EventsCount]: "eventsCount",
    [DashboardMetricKey.NewUserSignups]: "newUserSignups",
    [DashboardMetricKey.NoShowRate]: "noShowRate",
    [DashboardMetricKey.ClassCapacityUtilization]: "classCapacityUtilization",
    [DashboardMetricKey.RevenueFromPlans]: "revenueFromPlans",
    [DashboardMetricKey.StaffCommission]: "staffCommission",
    [DashboardMetricKey.NewVsReturningUsersRatio]: "newVsReturningUsersRatio",
    [DashboardMetricKey.AverageClassSize]: "averageClassSize",
    [DashboardMetricKey.ClassesTaught]: "classesTaught",
    [DashboardMetricKey.PeakHours]: "peakHours",
    [DashboardMetricKey.MostPopularClasses]: "mostPopularClasses",
    [DashboardMetricKey.TotalActiveUsers]: "totalActiveUsers",
    [DashboardMetricKey.ExpiringPlans]: "expiringPlans",
    [DashboardMetricKey.LowAttendanceClasses]: "lowAttendanceClasses",
    [DashboardMetricKey.StoreTurnover]: "storeTurnover",
    [DashboardMetricKey.StoreSalesCount]: "storeSalesCount",
    [DashboardMetricKey.StoreGrossProfit]: "storeGrossProfit",
    [DashboardMetricKey.StoreAverageOrderValue]: "storeAverageOrderValue",
    [DashboardMetricKey.StoreTopProducts]: "storeTopProducts",
    [DashboardMetricKey.StoreLowStock]: "storeLowStock",
    [DashboardMetricKey.StoreExpiringProducts]: "storeExpiringProducts",
  };
  return mapping[metricKey];
};
